import { z } from 'zod';
import { receiptPlacementSchema } from '../org/subdivision.js';
import { requisitionWithLinesSchema } from './requisition.schema.js';
import { requisitionStatusSchema } from './status.js';
/**
 * BERISH DALOLATNOMASI — mahsulot skladchidan qabul qiluvchiga o'tgan payt.
 *
 * Bu shakl oddiy o'tish so'rovi (`transitionRequisitionSchema`) bilan
 * ATAYLAB birlashtirilmagan. Berish — hujjat: unda kim oldi, qaysi lavozimda,
 * qaysi rasm bilan va qancha berildi degan savollarga javob bo'lishi shart.
 * Umumiy o'tish so'roviga bu maydonlarni tiqishtirish ularni QOLGAN o'n bitta
 * o'tish uchun ham ixtiyoriy qilib qo'yardi va "rasm majburiy" qoidasi
 * shaklning o'zida ko'rinmay qolardi.
 */
const idRef = z.string().regex(/^\d+$/, 'Identifikator raqamlardan iborat bo\'lishi kerak');
/** Fayl identifikatori — UUID (`stored_file.id`). */
const fileRef = z.string().uuid('Fayl identifikatori noto\'g\'ri');
/**
 * Bitta dalolatnomaga biriktiriladigan rasmlar soni.
 *
 * Chegara texnik emas, tashkiliy: hisobotni odam ko'zdan kechiradi va yigirma
 * rasmni hech kim ko'rmaydi. Ustki chegara bo'lmasa, bitta so'rov bilan
 * yuzlab fayl bog'lab yuborish mumkin bo'lardi.
 */
export const MAX_HANDOVER_PHOTOS = 10;
/**
 * Berilayotgan satr.
 *
 * `issuedQty` — HAQIQATDA berilgan miqdor va u tasdiqlangandan KAM bo'lishi
 * mumkin (omborda kam chiqdi, qabul qiluvchi hammasini olmadi). Ko'p bo'lishi
 * esa mumkin emas: tasdiqlanmagan mahsulot talabnoma zanjiridan o'tmagan bo'lardi.
 */
export const handoverLineSchema = z.object({
    lineId: idRef,
    issuedQty: z
        .number()
        .positive('Berilgan miqdor musbat bo\'lishi kerak')
        .max(99_999_999_999, 'Miqdor juda katta'),
    /**
     * CHETLANISH sababi — tasdiqlangandan kam berilganda yoki javondan
     * boshqa mahsulot olinganda.
     *
     * Satrda, hujjat izohida emas: «kam berildi» savoli har satrga alohida
     * beriladi va bitta umumiy izohga qo'shib yuborilsa, uch satrli
     * talabnomada qaysi satrga tegishli ekani yo'qolardi.
     *
     * Ixtiyoriy va bu ataylab: odatiy berishda chetlanish yo'q va bo'sh
     * izoh majburlansa, skladchi uni «ok» bilan to'ldirib o'rganib qolardi.
     */
    note: z.string().trim().min(3, 'Sabab juda qisqa').max(200).optional(),
});
/**
 * GPS — IXTIYORIY va bu ataylab.
 *
 * Ombor ichida (metall tokchalar, yerto'la) sun'iy yo'ldosh signali
 * bo'lmasligi oddiy hol. Koordinatani majburiy qilish berishni umuman
 * to'xtatib qo'yardi — ya'ni qoida ishning o'ziga to'sqinlik qilardi.
 */
export const gpsSchema = z.object({
    lat: z.number().min(-90).max(90),
    lng: z.number().min(-180).max(180),
});
/**
 * Berish so'rovi.
 *
 * `photoFileIds` sxemada BO'SH bo'lishi mumkin, lekin xizmat uni rad etadi
 * ("Kamida bitta rasm biriktirilishi shart"). Sabab: rasm majburiyligi —
 * shaklning emas, OQIMNING qoidasi (`hasPhoto`, state machine) va u bitta
 * aniq xabar bilan qaytishi kerak, sxema xatolari ro'yxati ichida emas.
 *
 * **Qabul qiluvchining ismi va lavozimi bu yerda YO'Q** — ilgari ular
 * majburiy edi va skladchi ularni har berishda qo'lda yozardi. Uch sabab
 * bilan olib tashlandi:
 *
 *   1. **Ma'lumot allaqachon hujjatda bor.** Buyurtmachi talabnomani
 *      yozayotganda kimni yuborishini ko'rsatgan (`throughPerson` — qog'ozdagi
 *      «Через кого»). Skladchi uni noldan qaytadan yozardi.
 *   2. **Lavozim ko'pincha bilinmaydi.** Kelgan odam haydovchi yoki ishchi
 *      bo'lsa, uning lavozimi ma'lumotnomada yo'q va skladchi taxminan
 *      birini tanlardi. Imzo satridagi taxmin bo'sh satrdan yomonroq.
 *   3. **Ular ФМУ-25 blankiga umuman tushmasdi.** Qog'ozdagi «Через кого»
 *      satri `throughPerson` dan to'ladi — ya'ni majburiy qilingan lavozim
 *      hech qachon qog'ozga yetib bormasdi.
 *
 * Dalolatnomadagi `receiverName` esa QOLADI: uni server talabnomaning
 * `throughPerson` idan ko'chiradi. Ya'ni "kim olib ketdi" degan savolga
 * javob yo'qolmadi — u faqat ikkinchi marta so'ralmaydigan bo'ldi.
 */
export const createHandoverSchema = z.object({
    photoFileIds: z.array(fileRef).max(MAX_HANDOVER_PHOTOS),
    gps: gpsSchema.optional(),
    lines: z
        .array(handoverLineSchema)
        .min(1, 'Kamida bitta satr berilishi kerak')
        .max(200),
    comment: z.string().max(500).optional(),
});
/**
 * Qabul tasdig'i — talabnomani YOPADIGAN qadam.
 *
 * Rasm bu yerda ham MAJBURIY. Ilgari u ixtiyoriy edi va sabab ham bor edi:
 * "skladchining hisoboti allaqachon rasm bilan". Lekin skladchining rasmi
 * boshqa savolga javob beradi — u nimani BERGANINI ko'rsatadi, buyurtmachi
 * nimani OLGANINI emas. Zanjirning oxirgi bo'g'ini dalilsiz qolsa, "berdim"
 * bilan "olmadim" o'rtasidagi bahsda hech kimning qo'lida hech narsa
 * bo'lmasdi.
 *
 * `photoFileIds` sxemada bo'sh bo'lishi MUMKIN, lekin xizmat uni rad etadi
 * (`createHandoverSchema` bilan aynan bir xil qaror): rasm majburiyligi —
 * shaklning emas, OQIMNING qoidasi va u bitta aniq xabar bilan qaytishi
 * kerak, sxema xatolari ro'yxati ichida emas.
 */
export const confirmReceiptSchema = z.object({
    photoFileIds: z.array(fileRef).max(MAX_HANDOVER_PHOTOS).optional(),
    /**
     * Qabul joyi — so'rovda IXTIYORIY, oqimda esa MAJBURIY.
     *
     * Ziddiyat emas, ikki manba: mijoz koordinatani bera oladi (brauzerning
     * joylashuv xizmati, faqat HTTPS da), bermasa esa server uni RASMNING
     * EXIF idan oladi. Sxema majburiy qilinsa, `http://` bilan ishlaydigan
     * ichki tarmoqda qabulni umuman qilib bo'lmasdi — u yerda brauzer
     * koordinatani bermaydi.
     *
     * Ikkalasi ham bo'lmasa, so'rov 400 bilan qaytadi va xabar NIMA
     * QILISHNI aytadi ("telefonda GPS ni yoqing").
     */
    gps: gpsSchema.optional(),
    comment: z.string().max(500).optional(),
    /** Hammasi qaysi ombor va zonaga tushadi — ixtiyoriy, jimlikda birinchi ombor. */
    storeroom: z
        .object({ storeroomId: z.string().regex(/^\d+$/), zoneId: z.string().regex(/^\d+$/).nullable() })
        .optional(),
    /** Partiya bo'yicha alohida joy — `storeroom` dan ustun turadi. */
    placements: z.array(receiptPlacementSchema).max(200).optional(),
});
/**
 * Dalolatnoma TURI: berish yoki qabul tasdig'i.
 *
 * Ikkalasi bitta jadvalda saqlanadi va bu ataylab: ikkalasi ham o'zgarmas
 * yozuv, ikkalasida ham rasm, izoh va koordinata bor. Ikkita deyarli bir xil
 * jadval yozilsa, ular albatta bir kun ajralib ketardi.
 */
export const HANDOVER_KINDS = ['ISSUE', 'RECEIPT'];
export const handoverKindSchema = z.enum(HANDOVER_KINDS);
export const handoverPhotoSchema = z.object({
    fileId: z.string(),
    /** Rasmning O'Z koordinatasi (EXIF dan) — dalolatnomanikidan farq qilishi mumkin. */
    gps: gpsSchema.nullable(),
});
export const handoverSchema = z.object({
    id: z.string(),
    requisitionId: z.string(),
    kind: handoverKindSchema,
    /**
     * Mahsulotni OLIB KETGAN odam — talabnomadagi «Kim orqali» dan ko'chiriladi.
     *
     * Buyurtmachi ko'rsatmagan bo'lsa `null`: yolg'on ism yozishdan ko'ra
     * bo'sh qoldirilgani yaxshiroq.
     */
    receiverName: z.string().nullable(),
    /**
     * ESKI maydon — endi HAR DOIM `null`.
     *
     * Lavozim so'ralmaydi (yuqoridagi izohga qarang). Ustun jadvalda qoladi:
     * dalolatnoma o'zgarmas yozuv va eski hujjatlardagi qiymat o'chirilmaydi.
     */
    receiverPositionId: z.string().nullable(),
    actorUserId: z.string(),
    gps: gpsSchema.nullable(),
    comment: z.string().nullable(),
    photos: z.array(handoverPhotoSchema),
    createdAt: z.string(),
});
/**
 * KO'RSATISH uchun rasm: fayl `id` siga NISBIY yo'l qo'shilgan.
 *
 * `url` — `files/<uuid>`, ya'ni API ning o'z manzili (`filePathOf`), saqlash
 * joyiniki EMAS. Ilgari bu yerda MinIO ning imzolangan havolasi turardi va
 * uning uchta kamchiligi bor edi: u 5 daqiqada o'lardi (sahifa ochiq tursa
 * rasm sinardi), `attachment` bilan kelardi (bosilganda rasm ochilmay,
 * yuklab olinardi) va MinIO ning O'ZIGA olib borardi — u esa ishlab
 * chiqarishda tashqi tarmoqqa umuman chiqarilmagan, ya'ni havola brauzerdan
 * ochilmasdi.
 *
 * Endi baytlarni API oqim qilib beradi (`GET /files/:id`), ya'ni ruxsat har
 * so'rovda qayta tekshiriladi va havolaning "muddati" degan tushuncha
 * umuman yo'qoladi.
 */
export const handoverPhotoViewSchema = handoverPhotoSchema.extend({
    url: z.string(),
});
/** Dalolatnomaning O'QISH ko'rinishi — yozish javobidan farqi faqat havolada. */
export const handoverViewSchema = handoverSchema.extend({
    photos: z.array(handoverPhotoViewSchema),
});
/**
 * Talabnomaning DALOLATNOMALARI — ko'pi bilan ikkita: berish va qabul tasdig'i.
 *
 * Sahifalash yo'q va kerak ham emas: ro'yxat cheklangan (`handover` jadvalida
 * talabnoma va tur bo'yicha UNIQUE indeks bor), sahifalash esa bo'lmagan
 * o'sishga tayyorgarlik bo'lardi.
 */
export const handoverListSchema = z.array(handoverViewSchema);
/**
 * Berish (yoki qabul tasdig'i) NATIJASI.
 *
 * Javobda dalolatnoma ham, YANGILANGAN talabnoma ham qaytadi: skladchi tugmani
 * bosgandan keyin ekran talabnomani QAYTA so'ramasligi kerak — oraliqda hujjat
 * eski holatda ko'rinib turardi. `availableTransitions` esa har doimgidek
 * serverdan keladi (`requisitionTransitionResultSchema` bilan bir xil qoida).
 */
export const handoverResultSchema = z.object({
    handover: handoverSchema,
    requisition: requisitionWithLinesSchema,
    availableTransitions: z.array(requisitionStatusSchema),
});
//# sourceMappingURL=handover.schema.js.map